import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from '@i18n';
import { CDN_LINK, serverUrl } from '@globalConfig';
import AddCarToCompare from "@/_MiniApps/CarCompare/Components/AddCarToCompare";
import ModernCardHeader from './ModernCardHeader';
import useHelpers from "@hooks/useHelpers";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { useCarCompareContext } from "@/_MiniApps/CarCompare/CarCompare";
// @ts-ignore

import { twMerge } from "tailwind-merge";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import ModernCardTags from "@/components/SearchComponent/ModernCard/ModernCardTags";
var ModernCard = function ModernCard(_ref) {
  var post = _ref.post,
    _ref$isEager = _ref.isEager,
    isEager = _ref$isEager === void 0 ? false : _ref$isEager,
    showGrantedPopup = _ref.showGrantedPopup,
    metaData = _ref.metaData,
    page = _ref.page,
    rank = _ref.rank,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$referralLocation = _ref.referralLocation,
    referralLocation = _ref$referralLocation === void 0 ? null : _ref$referralLocation,
    _ref$fromHomePage = _ref.fromHomePage,
    fromHomePage = _ref$fromHomePage === void 0 ? false : _ref$fromHomePage,
    _ref$isRecommendation = _ref.isRecommendations,
    isRecommendations = _ref$isRecommendation === void 0 ? false : _ref$isRecommendation,
    _ref$sectionType = _ref.sectionType,
    sectionType = _ref$sectionType === void 0 ? 'listing' : _ref$sectionType,
    _ref$is_rec = _ref.is_rec,
    is_rec = _ref$is_rec === void 0 ? false : _ref$is_rec,
    _ref$HasImageSlider = _ref.HasImageSlider,
    HasImageSlider = _ref$HasImageSlider === void 0 ? true : _ref$HasImageSlider,
    _ref$hideFavIcon = _ref.hideFavIcon,
    hideFavIcon = _ref$hideFavIcon === void 0 ? false : _ref$hideFavIcon,
    _ref$showGrantedLabel = _ref.showGrantedLabel,
    showGrantedLabel = _ref$showGrantedLabel === void 0 ? true : _ref$showGrantedLabel,
    _ref$showTags = _ref.showTags,
    showTags = _ref$showTags === void 0 ? true : _ref$showTags,
    _ref$showMarketingLab = _ref.showMarketingLabel,
    showMarketingLabel = _ref$showMarketingLab === void 0 ? true : _ref$showMarketingLab,
    _ref$showDiscountLabe = _ref.showDiscountLabel,
    showDiscountLabel = _ref$showDiscountLabe === void 0 ? true : _ref$showDiscountLabe,
    _ref$slideOnlyOnArr = _ref.slideOnlyOnArr,
    slideOnlyOnArr = _ref$slideOnlyOnArr === void 0 ? false : _ref$slideOnlyOnArr,
    _ref$isAnchor = _ref.isAnchor,
    isAnchor = _ref$isAnchor === void 0 ? false : _ref$isAnchor,
    _ref$titleTag = _ref.titleTag,
    titleTag = _ref$titleTag === void 0 ? "h2" : _ref$titleTag;
  var _useTranslation = useTranslation(['web_search']),
    t = _useTranslation.t;
  var location = useLocation();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var isBrowseSearch = location.pathname.includes("/autos") || fromHomePage;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var _useCarCompareContext = useCarCompareContext(),
    isCarIncludedToCompare = _useCarCompareContext.isCarIncluded,
    isCompareBarAllowed = _useCarCompareContext.isCompareBarAllowed;
  var TitleComp = titleTag;
  if (location.pathname.includes("/deal")) {
    referralLocation = "offerpage";
  }
  var listing_type = referralLocation ? referralLocation : searchParams.get("text") ? "search" : isBrowseSearch ? "browse" : "filter";
  var modifiedLink = createUrl(post === null || post === void 0 ? void 0 : post.product_url);
  var toLink = "".concat(modifiedLink).concat(isRecommendations ? "&rank=".concat(rank) : "").concat(page && rank && listing_type ? "#page_number=".concat(page, "&product_position=").concat(rank, "&listing_type=").concat(listing_type, "&logged_in=").concat(isLoggedIn) : "").concat(is_rec ? "#is_rec=1&product_position=".concat(rank, "&logged_in=").concat(isLoggedIn) : "");
  toLink = "".concat(toLink).concat(toLink.includes("#") ? "&" : "#").concat(sectionType ? "section_type=".concat(sectionType) : "");
  var Tag = isAnchor ? "a" : Link;
  var LinkType = isAnchor ? "href" : "to";
  return /*#__PURE__*/React.createElement("div", {
    className: twMerge("relative bg-white rounded-lg overflow-hidden shadow-md w-full cursor-pointer hover:shadow-lg h-full flex flex-col border-2 border-solid border-neutral-10 duration-200 transition-all", isCarIncludedToCompare(parseInt(post.id)) && isCompareBarAllowed() ? "border-2 border-primary border-solid" : ""),
    onClick: function onClick() {
      var params = {
        action: "click",
        query: searchParams.get("text") || "",
        pid: post.uniqueId,
        url: serverUrl + location.pathname + location.search,
        page: (metaData === null || metaData === void 0 ? void 0 : metaData.category_path) || "",
        page_type: metaData !== null && metaData !== void 0 && metaData.category_path ? "BOOLEAN" : ""
      };
      if (!isBrowseSearch || !(metaData !== null && metaData !== void 0 && metaData.category_path)) {
        // delete params.query;
        delete params.page;
        delete params.page_type;
      }
      if (isBrowseSearch && metaData !== null && metaData !== void 0 && metaData.category_path) {
        delete params.query;
      }
      unbxdAnalytics(params);
      _onClick && _onClick();
    }
  }, /*#__PURE__*/React.createElement(ModernCardHeader, {
    post: post,
    isEager: isEager,
    to_link: toLink,
    rank: rank,
    HasImageSlider: post.images_urls && post.images_urls.length > 1 && HasImageSlider,
    hideFavIcon: hideFavIcon,
    showMarketingLabel: showMarketingLabel,
    showDiscountLabel: showDiscountLabel,
    slideOnlyOnArr: slideOnlyOnArr,
    isAnchor: isAnchor
  }), /*#__PURE__*/React.createElement(Tag, _extends({}, _defineProperty({}, LinkType, toLink), {
    className: "p-3 !h-full flex flex-col justify-between"
  }), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(TitleComp, {
    className: "text-gray-text text-sm font-bold mb-2 text-start"
  }, post.title), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-slate text-xs text-right mb-0.5"
  }, t("شامل الضريبة", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 flex-wrap"
  }, post.sellingprice && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 text-success"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-xl font-bold"
  }, post.sellingprice), /*#__PURE__*/React.createElement("span", {
    className: "text-lg"
  }, t("ريال", {
    ns: "web_search"
  }))), post.monthly_installment && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-px h-8 bg-[#E9E9E9]"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 text-primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-xl font-bold"
  }, post.monthly_installment)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-primary text-xl"
  }, t("ريال", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-primary text-sm"
  }, "/"), /*#__PURE__*/React.createElement("span", {
    className: "text-primary text-sm"
  }, t("شهرياً", {
    ns: "web_common"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-500 text-sm min-h-[22px]"
  }, (post === null || post === void 0 ? void 0 : post.drop_price) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "font-bold "
  }, /*#__PURE__*/React.createElement("span", {
    className: " relative inline-block after:content-[''] after:absolute after:left-0 after:right-0 after:top-1/2 after:h-px after:bg-gray-500 after:-translate-y-1/2 "
  }, post === null || post === void 0 ? void 0 : post.drop_price)), /*#__PURE__*/React.createElement("span", {
    className: "font-medium"
  }, t("ريال", {
    ns: "web_search"
  })))))), /*#__PURE__*/React.createElement("div", null, showTags && post.tags && post.tags.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCardTags, {
    tags: post.tags,
    className: showGrantedLabel ? "" : "mb-0"
  })), showGrantedLabel ? /*#__PURE__*/React.createElement(React.Fragment, null, (post.condition_id == "0" || post.car_condition == "0") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-px bg-[#E9E9E9]"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pt-2 border-b border-[#E9E9E9] border-b-solid"
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("bg-[#EFF6FF] text-primary rounded-md py-1 px-1 flex justify-center cursor-default items-center gap-1 text-xs max-w-[132px] en:max-w-fit", showGrantedPopup && "cursor-pointer"),
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      showGrantedPopup && showGrantedPopup();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/garnteed.svg",
    width: 16,
    height: 16,
    alt: "garnteed",
    "aria-label": "garnteed"
  }), /*#__PURE__*/React.createElement("span", {
    className: "font-bold text-xs"
  }, t("مفحوصة ومضمونة", {
    ns: "web_search"
  })))))), (post.condition_id == "1" || post.car_condition == "1") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-px bg-[#E9E9E9]"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pt-2 border-b border-[#E9E9E9] border-b-solid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#EAFFF6] text-success rounded-md p-1 flex justify-center items-center gap-1 text-xs max-w-fit cursor-default",
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/new-garunteed.svg",
    width: 16,
    height: 16,
    alt: "garnteed",
    "aria-label": "garnteed"
  }), /*#__PURE__*/React.createElement("span", {
    className: "font-bold text-xs"
  }, t("ضمان الوكالة", {
    ns: "web_search"
  }))))))) : null)), /*#__PURE__*/React.createElement("div", {
    className: "px-3"
  }, /*#__PURE__*/React.createElement(AddCarToCompare, {
    car: post,
    className: "px-0"
  })));
};
export default ModernCard;